import { http, type HttpResponse } from 'interfaces'
import { type Position } from 'services'

export async function getPersonPositions (personId: number): Promise<HttpResponse<Position[]>> {
  return await http.get(`/api/v1/people/${personId}/positions/`).then(value => value.data).catch(reason => [])
}
